import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinpune() {



  const cardData = {
"keyword": "Tempo Traveller on rent in pune",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Tempo Traveller on rent in Pune for group travel, family trips, corporate outings, weddings, pilgrimages, and outstation tours. Whether you are planning a short city tour or a long-distance journey across Maharashtra and beyond, our Tempo Traveller service ensures a smooth and stress-free travel experience. With experienced drivers who are well-versed with highway routes and hill stations, clean and well-maintained air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable group travel solution from Pune. Our fleet includes 9-seater, 12-seater, 14-seater, 17-seater, and luxury Urbania Tempo Travellers suitable for small and large groups. With flexible rental options (local, outstation, and multi-day tours), doorstep pickup from Pune, easy booking, and 24/7 customer support, Shivai Travels ensures a comfortable and enjoyable journey for every group travel need.",

"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular weekend destinations near Pune, known for waterfalls, green valleys, caves, and scenic viewpoints. Tempo Travellers are commonly booked for group picnic tours here."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, and cool climate. It is a top choice for Tempo Traveller group tours from Pune."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba. Group devotees often book Tempo Travellers from Pune for comfortable darshan trips."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal beach destination near Mumbai known for beaches, forts, and resorts, making it a popular group outing destination from Pune."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, and religious tourism. It is frequently visited by families and groups using Tempo Traveller rentals."
  },
  {
    "title": "Goa",
    "description":
      "Goa is one of the most popular long-distance group travel destinations from Pune, known for beaches, nightlife, and water sports, ideal for Tempo Traveller road trips."
  },
  {
    "title": "Konkan Beaches (Murud, Kashid, Diveagar)",
    "description":
      "Konkan coastal beaches like Murud Janjira, Kashid, and Diveagar are popular group travel destinations from Pune for beach holidays and weekend trips."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description":
      "Ajanta and Ellora Caves near Aurangabad are UNESCO World Heritage Sites, often visited by large groups and school tours using Tempo Traveller rentals."
  },
  {
    "title": "Pune City Tour",
    "description":
      "Tempo Traveller rentals are also used for Pune city sightseeing tours covering Shaniwar Wada, Aga Khan Palace, Dagdusheth Temple, and other attractions."
  },
  {
    "title": "Western Ghats Scenic Routes",
    "description":
      "Tempo Traveller journeys from Pune often pass through the Western Ghats, offering scenic mountain views, ghats, waterfalls, and lush greenery for a comfortable group travel experience."
  }
],



services: [
  {
    name: "Tempo Traveller Hire Pune",
    description: "Tempo Traveller hire Pune service provides reliable group transportation for family trips, corporate tours, weddings, airport transfers, and outstation journeys. Comfortable vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include luxury Tempo Travellers with pushback seating, spacious interiors, and luggage space suitable for all travel needs. Flexible booking options allow convenient Tempo Traveller hire reservations in Pune."
  },
  {
    name: "Pune Tempo Traveller Rental",
    description: "Pune Tempo Traveller rental service offers dependable transportation solutions for groups traveling within Pune and outstation destinations. Vehicles provide spacious seating and comfortable highway travel suitable for tourism, pilgrimage tours, corporate outings, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient Tempo Traveller rental reservations."
  },
  {
    name: "Tempo Traveller on Rent Pune Price",
    description: "Tempo Traveller on rent Pune price service provides affordable and comfortable group travel options for local and outstation journeys. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for weddings, family vacations, and corporate travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Tempo Traveller reservations at budget-friendly pricing."
  },
  {
    name: "Tempo Traveller Booking Pune",
    description: "Tempo Traveller booking Pune service provides premium transportation for passengers seeking comfortable and reliable group travel. Vehicles offer spacious seating, luggage capacity, and smooth ride quality suitable for tourism, wedding events, family trips, and corporate outings. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Tempo Traveller booking reservations."
  },
  {
    name: "Cheap Tempo Traveller Pune",
    description: "Cheap Tempo Traveller Pune service offers economical and comfortable transportation for small and large groups traveling within Pune and nearby destinations. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, outstation journeys, and group outings. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost Tempo Traveller reservations."
  },
  {
    name: "Luxury Tempo Traveller Pune",
    description: "Luxury Tempo Traveller Pune service offers premium transportation with modern interiors, pushback seats, spacious cabins, and comfortable ride quality for group travel. Vehicles are suitable for weddings, VIP travel, tourism, airport transfers, and corporate events. Professional chauffeurs ensure safe driving and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient luxury Tempo Traveller reservations."
  },
  {
    name: "12 Seater Tempo Traveller Pune",
    description: "12 seater Tempo Traveller Pune service provides comfortable transportation for small groups, families, and corporate teams traveling within Pune and outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, pilgrimage tours, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient 12 seater Tempo Traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller Pune",
    description: "17 seater Tempo Traveller Pune service offers spacious transportation for medium-sized groups traveling for family tours, corporate outings, weddings, and sightseeing trips. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 17 seater Tempo Traveller reservations."
  },
  {
    name: "20 Seater Tempo Traveller Pune",
    description: "20 seater Tempo Traveller Pune service provides reliable transportation for larger groups traveling for tours, weddings, pilgrimage trips, and corporate events. Vehicles offer spacious seating, luggage space, and comfortable travel suitable for local and outstation journeys. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 20 seater Tempo Traveller reservations."
  },
  {
    name: "Outstation Tempo Traveller Pune",
    description: "Outstation Tempo Traveller Pune service provides dependable transportation for long-distance group travel from Pune to tourist destinations, pilgrimage places, beaches, and hill stations. Comfortable vehicles ensure smooth highway travel suitable for tourism, corporate tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient outstation Tempo Traveller reservations."
  },
  {
    name: "Pune Tempo Traveller for Family Trip",
    description: "Pune Tempo Traveller for family trip service offers spacious and comfortable transportation for families planning vacations, sightseeing tours, religious travel, and weekend getaways. Vehicles provide comfortable seating and luggage space suitable for safe and enjoyable family journeys. Professional drivers ensure punctual pickup and dependable transportation services throughout the trip. Pickup services are available from homes, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient family Tempo Traveller reservations."
  },
  {
    name: "Wedding Tempo Traveller Pune",
    description: "Wedding Tempo Traveller Pune service provides premium group transportation for wedding guests, family functions, receptions, and destination wedding travel. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and event transportation. Professional chauffeurs ensure safe driving and timely pickup services for all wedding travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient wedding Tempo Traveller reservations."
  },
  {
    name: "Airport Tempo Traveller Pune",
    description: "Airport Tempo Traveller Pune service offers reliable group transportation for airport pickup and drop services from Pune Airport and nearby locations. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual airport transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport Tempo Traveller reservations."
  },
  {
    name: "Pune Tempo Traveller Rental Service",
    description: "Pune Tempo Traveller rental service provides complete transportation solutions for local and outstation group travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, pilgrimage tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Tempo Traveller rental service reservations."
  },
  {
    name: "Best Tempo Traveller in Pune",
    description: "Best Tempo Traveller in Pune service offers comfortable and dependable group transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for weddings, family trips, airport transfers, sightseeing tours, and outstation travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Tempo Traveller reservations for all travel requirements."
  }
],

tableData: [
  ["Tempo Traveller Hire Pune", "Pune Tempo Traveller Rental"],
  ["Tempo Traveller on Rent Pune Price", "Tempo Traveller Booking Pune"],
  ["Cheap Tempo Traveller Pune", "Luxury Tempo Traveller Pune"],
  ["12 Seater Tempo Traveller Pune", "17 Seater Tempo Traveller Pune"],
  ["20 Seater Tempo Traveller Pune", "Outstation Tempo Traveller Pune"],
  ["Pune Tempo Traveller for Family Trip", "Wedding Tempo Traveller Pune"],
  ["Airport Tempo Traveller Pune", "Pune Tempo Traveller Rental Service"],
  ["Best Tempo Traveller in Pune", "Tempo Traveller Hire Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller on Rent in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Tempo Traveller rental service in Pune with professional drivers, comfortable seating, and punctual pickup for smooth group travel experiences."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Rental Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Tempo Traveller on rent in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Availability",
        WhyChoosedescription: "Our Tempo Traveller rental service in Pune operates 24 hours a day for family tours, corporate outings, weddings, pilgrimage trips, airport transfers, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance and local travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Booking Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Tempo Traveller booking, round-trip travel, local sightseeing, outstation tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Options",
        WhyChoosedescription: "Customers can choose from 9 seater, 12 seater, 13 seater, 17 seater, 20 seater, and luxury Tempo Travellers suitable for families, tourists, wedding guests, and corporate groups."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Group Tours",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune city routes, highways, hill stations, Konkan roads, and pilgrimage destinations, ensuring safe driving and smooth travel for every group journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller rental service in Pune?", answer: "Tempo Traveller rental service in Pune provides comfortable group transportation for family trips, corporate travel, weddings, sightseeing tours, and outstation journeys." },
    { question: "Is Tempo Traveller on rent in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Tempo Traveller rental service in Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Shivai Travels offers 9 seater, 12 seater, 13 seater, 17 seater, 20 seater, and luxury Tempo Travellers." },
    { question: "Can I book Tempo Traveller for outstation travel?", answer: "Yes, customers can book Tempo Travellers for local sightseeing, outstation tours, corporate travel, and pilgrimage trips." },
    { question: "Do you provide one-way and round-trip Tempo Traveller service?", answer: "Yes, Shivai Travels provides both one-way and round-trip Tempo Traveller booking services." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Tempo Traveller on rent in Pune online?", answer: "Yes, customers can easily book Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for weddings and corporate events?", answer: "Yes, Shivai Travels provides Tempo Travellers for weddings, corporate outings, events, and family group travel." },
    { question: "Are Tempo Traveller rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and wedding seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Patil",
    feedback:
      "Had a comfortable Tempo Traveller on rent in Pune with spacious seating and a well-maintained vehicle, making our group trip smooth and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "The Tempo Traveller rental service in Pune was very reliable with a clean vehicle, professional driver, and perfect comfort for our family tour.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent in Pune",
  "image": "https://shivaitravels.com/assets/images/tempo-traveller-pune.jpg",
  "description": "Book Tempo Traveller on rent in Pune for family trips, weddings, airport transfers, and outstation travel. Shivai Travels offers 12, 17, and 20-seater tempo travellers with affordable pricing, luxury options, and professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivaitravels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹22/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/tempo-traveller-on-rent-pune"
  }
};







  return (
    <div>

<Helmet>
  <title>Tempo Traveller on Rent in Pune | 12-20 Seater Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Tempo Traveller on rent in Pune for family trips, weddings, airport transfers, and outstation tours. 12, 17, and 20-seater options available at affordable prices with luxury and standard variants."
  />

  <meta
    name="keywords"
    content="tempo traveller hire pune, pune tempo traveller rental, tempo traveller on rent pune price, tempo traveller booking pune, cheap tempo traveller pune, luxury tempo traveller pune, 12 seater tempo traveller pune, 17 seater tempo traveller pune, 20 seater tempo traveller pune, outstation tempo traveller pune, pune tempo traveller for family trip, wedding tempo traveller pune, airport tempo traveller pune, pune tempo traveller rental service, best tempo traveller in pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentinpune;